import { Component, OnDestroy, OnInit } from '@angular/core';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { sweetAlert } from 'src/app/utils/swal';
import { FleetService } from '../fleet-service/fleet.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ExcelService } from 'src/app/service/excel-service/excel.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import * as _ from 'underscore';
import { StaffService } from '../../staffs/staff-service/staff.service';


@Component({
  selector: 'app-fleet-equipments',
  templateUrl: './fleet-equipments.component.html',
  styleUrls: ['./fleet-equipments.component.css']
})
export class FleetEquipmentsComponent implements OnInit, OnDestroy {

  equipments = [];
  fleetList = [];
  filteredFleetList = [];
  search: any;
  equipmentHeader = ["Rig#", "Division", "Rig Type"];
  status = "active";
  selectedServiceArea = [];
  filteredServiceAreas = [];
  preServiceAreas = {};

  selectedStationManager = [];
  stationManagerList = [];
  preStaffList = {};
  constructor(
    private csvService: CsvService,
    private fleetService: FleetService,
    private equipmentService: EquipmentService,
    private excelService: ExcelService,
    private serviceArea:ServiceAreasService,
    private staffService:StaffService
  ) { }

  ngOnInit() {
    this.getFleetList();
    this.getEquipments();
    this.getServiceAreas();
    this.getStaffList();
  }

  getEquipments() {
    let queryParam = { isAddon: false };
    this.equipmentService.getEquipments(queryParam).subscribe(
      (data) => {
        if (data && data.length) {
          this.equipments = data;
        } else {
          this.equipments = [];
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.filteredServiceAreas = data
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ isFleetSection: true, status: this.status })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          this.stationManagerList =[]
          if (data) {
            this.fleetList = data.map((fleet) => {
              if(fleet.driver && fleet.driver.stationManager){
                this.stationManagerList.push(fleet.driver.stationManager)
              }
              const fleetEquipments = fleet.equipments || [];
              const matchedEquipments = this.equipments.map((equipment) => ({
                ...equipment,
                hasEquipment: fleetEquipments.includes(equipment._id)
              }));
              return {
                ...fleet,
                matchedEquipments: matchedEquipments
              };
            });

            this.stationManagerList = _.uniq(this.stationManagerList).sort();

            this.filterFleet();
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  filterFleet() {
    this.filteredFleetList = this.fleetList.filter((fleet) => {
      const serviceAreaMatch = this.selectedServiceArea.length === 0 ||
        fleet.serviceAreas.some(area => this.selectedServiceArea.includes(area));

      const stationManagerMatch = this.selectedStationManager.length === 0 ||
        (fleet.driver && this.selectedStationManager.includes(fleet.driver.stationManager));

      return serviceAreaMatch && stationManagerMatch;
    });
  }


  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  downloadReport() {
    this.excelService.genCapacityPlanning(this.equipments, this.filteredFleetList);
  }

  ngOnDestroy() {
    // cleanup logic
  }
}
